export default "__VITE_ASSET__BJTswJjL__"